import { getEnv } from '@/classes';

export default function useLeaflet(el, options){
    const leaflet = window.L;
    const tileHost = getEnv('VUE_APP_LEAFLET_MAP_URL') || 'tiles-eu.stadiamaps.com';

    const map = leaflet.map(el, {
        center: [50.5010789,4.4764595],
        zoom: 8,
        ...options
    });

    const osm = leaflet.tileLayer('https://' + tileHost + '/tiles/osm_bright/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a>',
        minZoom: 0,
        maxZoom: 20,
    }).addTo(map);

    if(options?.satellite != false){
        const world = leaflet.tileLayer('https://' + tileHost + '/tiles/alidade_satellite/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a>',
            minZoom: 0,
            maxZoom: 20,
        })

        var baseMaps = {
            "Standaard": osm,
            "Sateliet": world
        };

        leaflet.control.layers(baseMaps).addTo(map);
    }
    

    return map;
}